import React from "react";
import { Box, CardProps, Card, Skeleton, alpha } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colorSystem } from "../../theme";

const useStyles = makeStyles((theme) => ({
  workoutContainer: {
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.common.white, 0.04)
        : colorSystem.blue5,
    borderRadius: 8,
    padding: theme.spacing(2.5),
    cursor: "pointer",
    width: "100%",
    boxShadow: "none",
    border:
      theme.palette.mode === "dark"
        ? `1px solid ${alpha(theme.palette.common.white, 0.1)}`
        : "1px solid transparent",
    transition: "background-color 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.common.white, 0.08)
          : alpha(colorSystem.blue5, 0.75),
      borderColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.common.white, 0.16)
          : alpha(colorSystem.gray4, 0.6),
    },
  },
  header: {
    marginBottom: theme.spacing(1),
  },
  title: {
    width: "50%",
    height: 20,
    marginBottom: theme.spacing(0.8),
  },
  subtitle: {
    width: "40%",
    height: 16,
  },
  footer: {
    marginTop: theme.spacing(1.5),
    display: "flex",
    gap: theme.spacing(3),
  },
  footerItem: {
    width: 60,
    height: 16,
  },
}));
export interface WorkoutResultsSkeletonCard extends CardProps {}

export function WorkoutResultsSkeletonCard(props: WorkoutResultsSkeletonCard) {
  const s = useStyles();

  return (
    <Card className={s.workoutContainer}>
      <Box className={s.header}>
        <Skeleton variant="text" animation="wave" className={s.title} />
        <Skeleton variant="text" animation="wave" className={s.subtitle} />
      </Box>
    </Card>
  );
}
